import styled from 'styled-components';

export const RouterContainer = styled.div`
    width: 100%;
    height: 100%;   
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1 0 auto;
    width: 1024px;
`;
